import { Store } from "../../types/contexts/groupOwnerContext/store.types";

const initialState: Store = {
	groupOwner: null
};

export default initialState;
